// SelectedDateContext.js
import { createContext, useState, useContext } from 'react'

const SelectedDateContext = createContext()

export const useSelectedDate = () => {
    return useContext(SelectedDateContext)
}

export const SelectedDateProvider = ({ children, initialDate }) => {
    const [selectedDate, setSelectedDate] = useState(initialDate || null)

    return (
        <SelectedDateContext.Provider value={{ selectedDate, setSelectedDate }}>
            {children}
        </SelectedDateContext.Provider>
    )
}
